import React, { useState, useEffect, useContext, useRef } from "react";
import { AuthContext } from '../../comum/Context/auth.jsx';
import { api } from '../../services/api.js';

import './index.css'
import Menu from "../../comum/Menu";
import Footer from "../../comum/Footer";
import { useParams, useNavigate } from "react-router-dom";

function Ponto() {
    const [nome, setNome] = useState('');
    const [horario, setHorario] = useState('');
    const [Deschor, setDeschor] = useState('');
    const [saldo, setSaldo] = useState('');
    const [horaFim, setHoraFim] = useState('');
    const [jornada, setJornada] = useState('');
    const [trabalhado, setTrabalhado] = useState('');
    const [extraBanco, setExtraBanco] = useState('');
    const [atrasoBanco, setAtrasoBanco] = useState('');
    const [faltaBanco, setFaltaBanco] = useState('');
    const [bancoHora, setBancoHora] = useState('');
    const [tabelas, setTabela] = useState([]);
    const hoje = new Date();
    const mesAtual = String(hoje.getMonth() + 1).padStart(2, '0');
    const anoAtual = hoje.getFullYear();
    const [mesano, setMesAno] = useState(mesAtual + String(anoAtual));
    const chapa = localStorage.getItem("chapa");
    const navigate = useNavigate()

    useEffect(() => {
        const chapa = localStorage.getItem("chapa");
        if (!chapa) {
            navigate("/arbor/login"); // Redireciona se não for funcionário logado
        }
    }, []);

    function MudarData() {
        if (mesano === '') {
            const newdata = new Date().toLocaleDateString();
            setMesAno(newdata.substring(3, 5) + newdata.substring(6, 10));
        }
    }

    setTimeout(MudarData, 1);


    useEffect(() => {

        if (mesano === '') {
            <></>
        }
        else {
            setTabela([]);
            api.get('/ponto/' + chapa + '/total?data=' + mesano)
                .then(async (retorno) => {
                    await
                        setSaldo(retorno.data[0].saldo);
                    setHoraFim(retorno.data[0].horafinal);
                    setNome(retorno.data[0].nome);
                    setJornada(retorno.data[0].jornada);
                    setTrabalhado(retorno.data[0].trabalhado);
                    setExtraBanco(retorno.data[0].extra_banco);
                    setAtrasoBanco(retorno.data[0].atraso_banco);
                    setFaltaBanco(retorno.data[0].falta_banco);
                    setBancoHora(retorno.data[0].bancohora);

                    Buscarponto();

                })
                .catch((err) => {
                    console.log(err);
                });
        }
    }, [mesano]);

    function Buscarponto() {
        api.get('/ponto/' + chapa + '/lista?data=' + mesano)
            .then(async (retorno) => {
                await
                    setDeschor(retorno.data[0].descricao);
                setTabela(retorno.data);

            })
            .catch((err) => {
                console.log(err);
            });
    }

    function par(valor) {
        var total = valor / 2;
        if (valor % 2 == 0) {
            return ("PAR");
        } else {
            return ("IMPAR");
        }
    }

    function handleMesAno(dmesano) {
        setMesAno(dmesano);
    }


    return (
        <div>
            <Menu modulo="ARBOR" />
            <div className="container-fluid pagina-ponto">
                <div className="list-group offset-lg-3 col-lg-6">
                    <div className="list-group offset-lg-3 col-lg-6">

                        <div className="col-xl-12 col-lg-12 col-12">
                            <form id="formulario" name="formulario" action="montadependente.php" method="post">
                                <label className="form-label">Mês</label>
                                {/*<input type="month"
                                    id="month"
                                    className="form-control fontmenor texto_centro"
                                    aria-describedby="emailHelp"
                                    onChange={(e) => handleMesAno(e.target.value.substring(5, 7) + e.target.value.substring(0, 4))}
                                
                                >
                                </input>*/}
                                <input
                                    type="month"
                                    id="month"
                                    className="form-control fontmenor texto_centro"
                                    onChange={(e) => handleMesAno(e.target.value.substring(5, 7) + e.target.value.substring(0, 4))}
                                    value={`${mesano.substring(2, 6)}-${mesano.substring(0, 2)}`}
                                />
                            </form>
                        </div>
                    </div>
                    <a href="#" className="list-group-item list-group-item-action flex-column list-group-item-success">
                        <div className="d-flex w-100 justify-content-between">
                            <h6 className="mb-1">{nome}</h6>
                            <small className="text-muted"><b>{saldo}</b></small>
                        </div>
                        <small className="text-muted"><b>Horário:</b> {Deschor}</small>
                        <div className="d-flex w-100 justify-content-between">
                            <p className="mb-2"><b>Extra:</b> {extraBanco} </p>
                            <p className="mb-2"><b>Atraso:</b> {atrasoBanco} </p>
                            <p className="mb-2"><b>Falta:</b> {faltaBanco} </p>
                            <p className="mb-2"><b>Banco:</b> {bancoHora} </p>
                            <p className="mb-2"><b>Final:</b> {horaFim}</p>
                        </div>
                    </a>
                    <a href="#" className="list-group-item list-group-item-action list-group-item-warning">
                        <div className="row">
                            <div className="col-xl-1 col-lg-1 col-1 ">
                                ❓
                            </div>
                            <div className="col-xl-2 col-lg-2 col-2 ">
                                <small className="text-muted"><b>Dia</b></small>
                            </div>
                            <div className="col-xl-5 col-lg-51 col-5">
                                <small className="text-muted"><b>Marcações</b></small>
                            </div>

                            <div className="col-xl-2 col-lg-2 col-2">
                                <small className="text-muted"><b>Trab.</b></small>
                            </div>

                            <div className="col-xl-2 col-lg-2 col-2">
                                <small className="text-muted"><b>Ocor.</b></small>
                            </div>

                        </div>
                    </a>

                    {
                        tabelas.map((tabela) => {
                            return <a href="#" key={tabela.data} className={par(tabela.data) === "IMPAR" ? "list-group-item list-group-item-action list-group-item-light" : "list-group-item list-group-item-action list-group-item-primary"}>

                                <div className="row" key={tabela.data}>

                                    <div className="col-xl-1 col-lg-1 col-1 ">
                                        😊
                                    </div>
                                    <div className="col-xl-2 col-lg-2 col-2 ">

                                        <small className="text-muted"><b>{tabela.data} </b></small>
                                    </div>
                                    <div className="col-xl-5 col-lg-5 col-5">
                                        <small className="text-muted">{tabela.marcacoes}</small>
                                    </div>

                                    <div className="col-xl-2 col-lg-2 col-2">
                                        <small className="text-muted">{tabela.trabalhado}</small>
                                    </div>

                                    <div className="col-xl-2 col-lg-2 col-2">
                                        <small className="text-muted"><b>{tabela.ocorrencia}</b></small>
                                    </div>

                                </div>

                            </a>
                        })
                    }

                    {/*<a href="#" className="list-group-item list-group-item-action list-group-item-secondary">Um simples item secondary do grupo de lista</a>
                    <a href="#" className="list-group-item list-group-item-action list-group-item-success">Um simples item success do grupo de lista</a>
                    <a href="#" className="list-group-item list-group-item-action list-group-item-danger">Um simples item danger do grupo de lista</a>
                    <a href="#" className="list-group-item list-group-item-action list-group-item-warning">Um simples item warning do grupo de lista</a>
                    <a href="#" className="list-group-item list-group-item-action list-group-item-info">Um simples item info do grupo de lista</a>
                    <a href="#" className="list-group-item list-group-item-action list-group-item-light">Um simples item light do grupo de lista</a>
                    <a href="#" className="list-group-item list-group-item-action list-group-item-dark">Um simples item dark do grupo de lista</a>*/}
                </div>
            </div>
            <Footer />
        </div >
    )
}
export default Ponto;